import { createStyles } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = () =>
  createStyles({
    root: {},
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    message: {
      color: colours.neutral[600],
      fontWeight: 400,
    },
    resultWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    row: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 8,
    },

    failedLink: {
      color: colours.neutral[900],
      cursor: 'pointer',
      fontWeight: 500,
      textDecorationLine: 'underline',
    },
    successLink: {
      cursor: 'pointer',
      fontWeight: 500,
      textDecorationLine: 'underline',
    },
  });
